module.exports = "/_next/static/images/114b296abfdef07d227ea349a0e47821-pen@mobile480.jpg";